import { ChakraProvider } from "@chakra-ui/react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
import ReactDOM from "react-dom/client";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import APP_ROUTES from "./constant/APP_ROUTES";
import "./index.css";
import Home from "./pages/Home";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";
import Calendar from "./pages/Calendar";
import AOS from "aos";
import "aos/dist/aos.css";
import { TrackingProvider } from "./providers/TrackingProvider";
import CalendarPerpetual from "./pages/PerpetualCalendar";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ChakraProvider theme={theme}>
    <Router>
      <TrackingProvider>
        <Routes>
          <Route path={APP_ROUTES.HOME} element={<Home />} />
          <Route path={APP_ROUTES.CALENDAR} element={<Calendar />} />
          <Route
            path={APP_ROUTES.CALENDAR_PERPETUAL}
            element={<CalendarPerpetual />}
          />
        </Routes>
      </TrackingProvider>
    </Router>
  </ChakraProvider>,
);

AOS.init({
  duration: 1000,
  once: false,
  easing: "ease-in-out",
});

reportWebVitals();
